<template>
  <div @click="toggleShowShopDetail" class="meal-item-container" :class="{'disabled': disabled}" :title="meal_info.menu_name">
    <span class="title">
      <span v-if="meal_info.tag_name.length" class="label">{{ meal_info.tag_name }}</span>
      <span class="name-box">
        <span class="name">{{ titleText }}</span>
        <span class="remark">{{ meal_info.menu_notice }}</span>
      </span>
    </span>
    <img class="img" :src="meal_info.photo" @error="errorLoadImg()">
    <span class="month-sale">月销量：{{ meal_info.menu_count }}</span>
    <span class="month-sale"  v-if="meal_info.number > 0" :class="{hide:!meal_info.left_number}">最多添加{{ meal_info.left_number }}件</span>
    <div class="break-line"/>
    <div class="price-view">
      <span class="price">
        <span>¥{{ meal_info.dis_price ? meal_info.dis_price : meal_info.actual_price }}</span>
        <span v-if="meal_info.dis_price" class="dis_price">¥{{ meal_info.actual_price }}</span>
      </span>
      <!--  -->
      <span class="count-view">
        <img
          v-show="shoppingCartMealCount"
          @click.stop="changeMealCount(-1)"
          class="minus"
          src="../../../static/img/meals/icon_sc.png"
        >
        <span v-if="meal_info.number > 0 && !meal_info.left_number">售罄</span>
        <span class="count" v-else>{{ shoppingCartMealCount }}</span>
        <!-- <img
          v-if="disabled"
          @click.stop="changeMealCount(1)"
          class="add"
          src="../../../static/img/meals/icon_tj_pre.png"
        > -->
        <img
          v-if="!disableAdd(meal_info)"
          @click.stop="changeMealCount(1)"
          class="add"
          src="../../../static/img/meals/icon_tj.png"
        >
      </span>
    </div>
  </div>
</template>

<script>
import DEFAULT_IMG from "../../../static/img/meals/pic_home_default.png";

export default {
  name: "MealItem",
  props: {
    meal_info: {
      type: Object,
      default: {}
    },
    select_id: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mealCount: 0
    };
  },
  computed: {
    /**
     * 购物车里的商品数量，初始显示为0，当添加进购物车后，显示当前商品在购物车里的数量
     */
    shoppingCartMealCount() {
      if (this.$store.state.shopping_cart_data.length === 0) {
        this.mealCount = 0;
        return 0;
      }
      let itemIndex = -1,
        dataIndex = -1;
      this.$store.state.shopping_cart_data.map((items, index) => {
        items.map((item, i) => {
          if (
            this.meal_info.menu_id === item.menu_id &&
            this.meal_info.menu_spec_id === item.menu_spec_id
          ) {
            dataIndex = index;
            itemIndex = i;
          }
        });
      });
      if (itemIndex > -1 && dataIndex > -1) {
        return this.$store.state.shopping_cart_data[dataIndex][itemIndex]
          .meal_count;
      } else {
        return 0;
      }
    },
    /**
     * 商品图片url，没有图片时显示默认图片
     */
    imgUrl() {
      return this.$store.state.avatar_url === ""
        ? DEFAULT_IMG
        : this.$store.state.avatar_url;
    },
    titleText() {
      return this.meal_info.menu_name
      // return this.meal_info.menu_name.length > 6
      //   ? this.meal_info.menu_name.slice(0, 6) + "..."
      //   : this.meal_info.menu_name;
    },
    disableAdd () {
      return function (foods_detail) {
        // number为0是指没有限制份数 number大于0 是指限制了份数
        if (foods_detail.number > 0) { return !this.checkDisabled ||  !(this.shoppingCartMealCount < foods_detail.left_number) } else {
          return !this.checkDisabled
        }
      }
    }
  },
  methods: {
    /**
     * 检查是否能够下单，不能下单给出提示
    */
    checkDisabled () {
      if (this.disabled) {
        this.$store.commit('show_alert', '暂未开启下单')
      }
      return this.disabled
    },
    /**
     * 改变商品数量，商品数量不可小于0
     */
    changeMealCount(key) {
      if (this.checkDisabled()) { return }
      // 打开购物车
      this.$store.commit("toggle_show_shopping_cart", true);
      // 设置数量可响应式
      this.$set(this.meal_info, "meal_count", this.shoppingCartMealCount + key);
      this.meal_info.busi_id = this.$store.state.meals.busi_id;
      this.meal_info.dis_id = this.$store.state.meals.dis_id;
      this.meal_info.busi_name = this.$store.state.meals.busi_name;
      this.meal_info.select_id = this.select_id;
      this.meal_info.remarks = "";
      this.$store.commit("set_shopping_cart_data", this.meal_info);
    },
    /**
     * 显示商品详情页面
     */
    toggleShowShopDetail() {
      if (this.checkDisabled()) { return }
      let count =
        this.shoppingCartMealCount === 0 ? 1 : this.shoppingCartMealCount;
      // 设置数量可响应式
      this.$set(this.meal_info, "meal_count", count);
      this.meal_info.busi_id = this.$store.state.meals.busi_id;
      this.meal_info.dis_id = this.$store.state.meals.dis_id;
      this.meal_info.busi_name = this.$store.state.meals.busi_name;
      this.meal_info.select_id = this.select_id;
      this.meal_info.remarks = "";
      this.$store.commit("toggle_show_shop_detail", this.meal_info);
    },
    /**
     * 如果图片加载出错，显示默认图片
     */
    errorLoadImg() {
      const eventTag = event.toElement || event.target;
      eventTag.src = "../../../static/img/meals/pic_home_default.png";
    }
  }
};
</script>

<style lang="less" scoped>
.meal-item-container {
  width: 220px;
  // height: 310px; // 300px
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  margin-top: 30px;
  cursor: pointer;
  padding-bottom: 10px;
  &.disabled {
    cursor: not-allowed;
    .price-view .add {
      cursor: not-allowed;
    }
  }
  .hide{
    opacity: 0;
  }
  .title {
    height: 50px; // 40px
    width: 200px; // 180px
    display: flex;
    justify-content: center;
    align-items: flex-start;
    margin-top: 15px;
    margin-left: 5px;
    margin-right: 5px;
    font-size: 20px;
    color: #333333;
    font-weight: bold;
    .label {
      margin-top: 3px;
      width: 36px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;
      font-size: 14px;
      color: #ff7814;
      background-image: url("../../../static/img/meals/biaoqian.png");
    }
    .name-box {
      max-width: 158px;
      .name {
        display: inline-block;
        display: flex;
        justify-content: center;
        // align-items: center;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .remark {
        position: relative;
        top: -5px;
        display: inline-block;
        max-width: 158px;
        font-size: 12px;
        color: #a5a5a5;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .img {
    width: 140px;
    height: 140px;
    border-radius: 70px;
    margin-top: 18px;
  }
  .month-sale {
    margin-top: 2px;
    font-size: 16px;
    color: #ff7814;
  }
  .star {
    width: 16px;
    height: 16px;
    margin: 5px;
  }
  .break-line {
    width: 184px;
    margin-top: 10px;
    margin-bottom: 5px;
    border-bottom: 1px solid #e0e0e0;
  }
  .price-view {
    width: 184px;
    height: 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    .price {
      font-size: 20px;
      color: #333333;
      .dis_price {
        text-decoration: line-through;
        font-size: 16px;
        color: #999999;
      }
    }
    .count-view {
      height: 24px;
      display: flex;
      justify-content: center;
      text-align: center;
    }
    .count {
      width: 30px;
      display: inline-block;
      font-size: 18px;
      color: #333333;
    }
    .minus,
    .add {
      width: 24px;
      height: 24px;
      cursor: pointer;
    }
  }
}
.meal-item-container:hover {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/meals/meal_item.vue